import { render, staticRenderFns } from "./data77.vue?vue&type=template&id=3057ac42&scoped=true"
import script from "./data77.vue?vue&type=script&lang=js"
export * from "./data77.vue?vue&type=script&lang=js"
import style1 from "./data77.vue?vue&type=style&index=1&id=3057ac42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057ac42",
  null
  
)

export default component.exports